export default __webpack_public_path__ + "static/media/dialog_borderbox.c5432d54.png";